import tippy, { roundArrow } from "tippy.js";
import { debounce } from 'lodash';

(function (cash) {
    "use strict";

    window.currentTippy = [];
    // Tooltips
    cash(".tooltip").each(function () {
        let options = {
            content: cash(this).attr("title"),
        };

        if (cash(this).data("trigger") !== undefined) {
            options.trigger = cash(this).data("trigger");
        }

        if (cash(this).data("placement") !== undefined) {
            options.placement = cash(this).data("placement");
        }

        if (cash(this).data("theme") !== undefined) {
            options.theme = cash(this).data("theme");
        }

        if (cash(this).data("tooltip-html") !== undefined) {
            options.allowHTML = true;
        }

        if (cash(this).data("tooltip-content") !== undefined) {
            options.content = cash(this).data("tooltip-content");
        }

        cash(this).removeAttr("title");

        window.currentTippy.push( tippy(this, {
            arrow: roundArrow,
            animation: "shift-away",
            ...options,
        })
        );
    });



    window.refreshTippy = _.debounce(function(){
        if( window.currentTippy.length > 0 ){
            cash.each( window.currentTippy, function(index,obj){
                obj.destroy();
            });
            window.currentTippy = [];
        }
        cash(".tooltip[title], .tooltip").each(function () {

            let options = {
                content: cash(this).attr("title"),
            };

            if (cash(this).data("trigger") !== undefined) {
                options.trigger = cash(this).data("trigger");
            }

            if (cash(this).data("placement") !== undefined) {
                options.placement = cash(this).data("placement");
            }

            if (cash(this).data("theme") !== undefined) {
                options.theme = cash(this).data("theme");
            }

            if (cash(this).data("tooltip-html") !== undefined) {
                options.allowHTML = true;
            }

            if (cash(this).data("tooltip-content") !== undefined) {
                options.content = cash(this).data("tooltip-content");
            }

            cash(this).removeAttr("title");

            window.currentTippy.push( tippy(this, {
                arrow: roundArrow,
                animation: "shift-away",
                ...options,
            })
            );
        });
    },5000,{leading:true,trailing:false});
})(cash);
